// @flow
import React from "react";
import styled from "styled-components";
import { media } from "@nested/ui";

const Burger = styled.label`
  cursor: pointer;
  display: block;
  float: right;
  width: 32px;
  height: 32px;
  padding-top: 4px;
  padding-bottom: 4px;
  -webkit-tap-highlight-color: transparent;
  margin-left: 20px;

  & > div {
    width: 100%;
    width: 27px;
    background-color: #353f52;
    margin: auto;
    height: 2px;
    margin-bottom: 6px;
  }
`;

const Cross = styled.label`
  cursor: pointer;
  display: block;
  width: 24px;
  height: 24px;
  padding: 4.5px;
  position: absolute;
  top: 15px;
  right: 15px;
  -webkit-tap-highlight-color: transparent;
  z-index: 100;

  div:first-child {
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    bottom: 0;
    width: 24px;
    height: 2px;
    background-color: #353f52;
    transform: rotate(45deg);
  }
  div:last-child {
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    bottom: 0;
    width: 24px;
    height: 2px;
    background-color: #353f52;
    transform: rotate(-45deg);
  }

  ${media.tablet`
    display: none;
  `};
`;

export const Phone = () => (
  <a href="tel:+442038580695">
    <svg width="27" height="27" viewBox="0 0 30 30">
      <g fill="none" fillRule="evenodd">
        <path fillRule="nonzero" d="M-1-1h32v32H-1z" />
        <path
          stroke="#353F52"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M25.343 26.657l2.243-2.243a2 2 0 0 0 0-2.828l-4.172-4.172a2 2 0 0 0-2.828 0L19 19c-4 4-12-4-8-8l1.586-1.586a2 2 0 0 0 0-2.828L8.414 2.414a2 2 0 0 0-2.828 0L3.343 4.657c-1.5 1.5-2.404 3.545-2.14 5.65 1.264 10.125 8.365 17.226 18.49 18.49 2.105.264 4.15-.64 5.65-2.14z"
        />
        <path
          fill="#353F52"
          d="M15 6a1 1 0 0 1 1-1 9 9 0 0 1 9 9 1 1 0 1 1-2 0 7 7 0 0 0-7-7 1 1 0 0 1-1-1z"
        />
        <path
          fill="#353F52"
          d="M15 2a1 1 0 0 1 1-1c7.18 0 13 5.82 13 13a1 1 0 1 1-2 0c0-6.075-4.925-11-11-11a1 1 0 0 1-1-1z"
        />
      </g>
    </svg>
  </a>
);

export const OpenMenu = () => (
  <Burger htmlFor="nav-toggle">
    <div />
    <div />
    <div />
  </Burger>
);

export const CloseMenu = () => (
  <Cross htmlFor="nav-toggle">
    <div />
    <div />
  </Cross>
);
